module.exports = __webpack_public_path__ + "img/sent.86334feb.svg";